<template>
  <div id="app">
    <router-view />
  </div>
</template>

<script>
export default {
  name: 'App'
};
</script>

<style>
/* These three CSS modules will be needed for all apps */
@import '@moodxd/base-reset';
@import '@moodxd/base-typography';
@import '@moodxd/theme-core';

/* These modules are needed for the included pages, and probably for all apps */
@import '@moodxd/layout-container';
@import '@moodxd/layout-grid';
@import '@moodxd/utility-size';
@import '@moodxd/utility-space';

/*
 These modules are needed for navigation items
 */
@import '@moodxd/component-corporate-navigation';
@import '@moodxd/component-section-navigation';
@import '@moodxd/component-section-title';
@import '@moodxd/component-site-navigation';
@import '@moodxd/component-footer';

/* For all form elements */
@import "@moodxd/component-form";

/*
  These modules are also available.  To keep your CSS bundle as small as possible,
  you should only un-comment the ones that you need.
 */
/* @import '@moodxd/component-accordion'; */
@import '@moodxd/component-card';
/* @import '@moodxd/component-decorative-number'; */
/* @import '@moodxd/component-form'; */
/* @import '@moodxd/component-hero'; */
/* @import '@moodxd/component-narrative-form'; */
/* @import '@moodxd/component-overlay'; */
/* @import '@moodxd/component-tabs'; */
@import '@moodxd/element-button';
@import '@moodxd/element-checkbox';
/* @import '@moodxd/element-dropdown'; */
@import '@moodxd/element-input';
/* @import '@moodxd/element-link'; */
@import '@moodxd/element-loader';
/* @import '@moodxd/element-radio'; */
@import '@moodxd/element-select';
/* @import '@moodxd/element-table'; */
/* @import '@moodxd/element-textarea'; */
/* @import '@moodxd/element-tooltip'; */
/* @import '@moodxd/utility-flex'; */
/* @import '@moodxd/utility-layout'; */
/* @import '@moodxd/utility-offset'; */
/* @import '@moodxd/utility-order'; */
/* @import '@moodxd/utility-properties'; */
/* @import '@moodxd/utility-typography'; */
@import '@moodxd/component-global-message';
@import '@moodxd/component-inline-message';

</style>
